import { CONTACT_EMAIL, EULA_URL, PRIVACY_URL } from '../lib/legal'
import { openExternalLink } from '../lib/openExternal'

type Props = {
  onPrivacy?: () => void
  onTerms?: () => void
  /** Show web URLs in addition to in-app navigation. */
  showWebUrls?: boolean
}

export function LegalLinks({ onPrivacy, onTerms, showWebUrls = true }: Props) {
  const linkClass =
    'text-xs text-foam-faint underline-offset-2 hover:text-whiskey-light hover:underline'

  return (
    <div className="space-y-2 text-center">
      <div className="flex flex-wrap items-center justify-center gap-x-3 gap-y-1">
        {onPrivacy ? (
          <button type="button" className={linkClass} onClick={onPrivacy}>
            Privacy Policy
          </button>
        ) : (
          <a
            className={linkClass}
            href={PRIVACY_URL}
            target="_blank"
            rel="noopener noreferrer"
            onClick={(event) => openExternalLink(event, PRIVACY_URL)}
          >
            Privacy Policy
          </a>
        )}
        <span className="text-foam-faint/40" aria-hidden>
          ·
        </span>
        {onTerms ? (
          <button type="button" className={linkClass} onClick={onTerms}>
            Terms of Use (EULA)
          </button>
        ) : (
          <a
            className={linkClass}
            href={EULA_URL}
            target="_blank"
            rel="noopener noreferrer"
            onClick={(event) => openExternalLink(event, EULA_URL)}
          >
            Terms of Use (EULA)
          </a>
        )}
      </div>
      <p className="text-xs text-foam-muted">
        <a className={linkClass} href={`mailto:${CONTACT_EMAIL}`}>
          {CONTACT_EMAIL}
        </a>
      </p>
      {showWebUrls ? (
        <p className="text-[10px] text-foam-faint/60">
          Web copies:{' '}
          <a
            className={linkClass}
            href={PRIVACY_URL}
            target="_blank"
            rel="noopener noreferrer"
            onClick={(event) => openExternalLink(event, PRIVACY_URL)}
          >
            {PRIVACY_URL.replace('https://', '')}
          </a>
          {' · '}
          <a
            className={linkClass}
            href={EULA_URL}
            target="_blank"
            rel="noopener noreferrer"
            onClick={(event) => openExternalLink(event, EULA_URL)}
          >
            {EULA_URL.replace('https://', '')}
          </a>
        </p>
      ) : null}
    </div>
  )
}
